module.exports = __webpack_public_path__ + "static/house-3.f933accc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/house/house-3.png
// module id = 601
// module chunks = 263791100135453